/* eslint-disable no-bitwise, no-nested-ternary */
import { defaultAvatarColors } from '@/constants/avatar'
import { getItemByHashString } from '@/utils/array'

export const lightenDarkenColor = (color: string, percent: number): string => {
  const num = parseInt(color.replace('#', ''), 16)
  const R = Math.round((num >> 16) + (255 - (num >> 16)) * (percent / 100))
  const B = Math.round(((num >> 8) & 0x00ff) + (255 - ((num >> 8) & 0x00ff)) * (percent / 100))
  const G = Math.round((num & 0x0000ff) + (255 - (num & 0x0000ff)) * (percent / 100))
  return `#${(
    0x1000000 +
    (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
    (B < 255 ? (B < 1 ? 0 : B) : 255) * 0x100 +
    (G < 255 ? (G < 1 ? 0 : G) : 255)
  )
    .toString(16)
    .slice(1)}`
}

export const getColorByString = (string: string) => getItemByHashString(string, defaultAvatarColors)

export const isColorTooLight = (hexColor: string, threshold: number = 0.8): boolean => {
  const color = hexColor.replace(/^#/, '')

  const r = parseInt(color.length === 3 ? color[0] + color[0] : color.slice(0, 2), 16) / 255
  const g = parseInt(color.length === 3 ? color[1] + color[1] : color.slice(2, 4), 16) / 255
  const b = parseInt(color.length === 3 ? color[2] + color[2] : color.slice(4, 6), 16) / 255

  // https://www.w3.org/TR/WCAG21/#dfn-relative-luminance
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b
  return luminance > threshold
}
